import {AdverAxios} from "../../common/Axios";
const TERMS_LIST = '/policy/terms';
const TERMS_INFO = '/policy/latest-terms';
/**
 * 전체 약관 정보 가져오기 api
 * @returns {Promise<null>}
 */
export async function selPolicyTerms() {
  let returnVal = null;
  await AdverAxios('GET', TERMS_LIST, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 약관 정보 수정
 * @param userInfo
 * @returns {Promise<null>}
 */
export async function updateTerms(terms) {
  let returnVal = null;
  await AdverAxios('PUT', TERMS_LIST + "/" + terms.id, terms)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = true;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};
/**
 * 약관 정보 가져오기 api
 * @returns {Promise<null>}
 */
export async function selPolicyTermsById(id) {
  let returnVal = null;
  await AdverAxios('GET', TERMS_LIST + "/" + id, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 최신 약관 정보 가져오기 api
 * @returns {Promise<null>}
 */
export async function selPolicyLatestTerms() {
  let returnVal = null;
  await AdverAxios('GET', TERMS_INFO, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}